import { FlujoTesoreriaReadingDtoProps } from "./DTOs/FlujoTesoreriaReadingDto"

export const flujosTesoreriaById = (
  pagoCobro: FlujoTesoreriaReadingDtoProps
): FlujoTesoreriaReadingDtoProps => {
  return {
    id: pagoCobro.id,
    cuentaBancariaId: pagoCobro.cuentaBancariaId,
    descripcion: pagoCobro.descripcion,
    empresaId: pagoCobro.empresaId,
    fecha: pagoCobro.fecha,
    importe: pagoCobro.importe,
    razonSocial: pagoCobro.razonSocial,
    remesaId: pagoCobro.remesaId,
    tipo: pagoCobro.tipo,
    tipoRemesable: pagoCobro.tipoRemesable,
  }
}
